import Vue from 'vue';
import grmVueModal from 'grm-vue-modal';
Vue.use(grmVueModal);
